module.exports = __webpack_public_path__ + "static/media/youtube-head.24f6bc3b.png";